/** Id del landmark `<main>` del layout que actúa como shell de la página. Lo reutilizan el skip link (TAN-8654) y `useRouteFocusHandler` (TAN-9802). */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * Ancho real del sidebar de `LayoutSidebarResponsive` publicado en `:root`: el ancho del
 * panel mientras está abierto y el del raíl (48px) mientras está colapsado — el raíl sigue
 * en pantalla, así que los consumidores deben compensarlo igualmente. Solo se borra con el
 * panel deshabilitado o al desmontar. Existe porque hay reglas que necesitan el
 * desplazamiento del contenido pero cuelgan de `body` u otro ancestro del layout, donde una
 * custom property definida en el propio layout no es visible: p. ej. el visor Fixed Layout
 * (`body.is-fixed-layout-viewer .viewer-dialog`).
 */
export const SIDEBAR_OFFSET_LEFT_CSS_VAR = '--layout-sidebar-offset-left';

/**
 * Umbral (px de `window.innerWidth`) por debajo del cual `LayoutSidebarResponsive` trata el
 * viewport como móvil: el panel abierto pasa a ser un overlay a pantalla completa. Debe
 * coincidir con el breakpoint `$size-medium` que usa su SCSS.
 */
export const SIDEBAR_MOBILE_BREAKPOINT = 768;

/**
 * Id del contenedor del contenido del sidebar. Lo referencian por `aria-controls` los
 * controles que lo manipulan: el `<<`/`>>` de colapso (aria-expanded) y el tirador de
 * redimensionado (patrón APG Window Splitter).
 */
export const SIDEBAR_CONTENT_ID = 'layout-sidebar-content';
